import { AppNotification, NotificationTypeEnum } from '@app/common';
import { NotificationDto } from '../../defs/api';

const assertNever = (notification: never): never => {
    throw new Error(`Unsupported notification type: ${JSON.stringify(notification)}`);
};

export const notificationFromApi = (notification: NotificationDto): AppNotification => {
    switch (notification.type) {
        case 'portfolioValueChanged':
            return { ...notification, type: NotificationTypeEnum.PortfolioValueChanged };
        case 'portfolioMilestoneReached':
            return { ...notification, type: NotificationTypeEnum.PortfolioMilestoneReached };
        case 'dividendPayment':
            return { ...notification, type: NotificationTypeEnum.DividendPayment };
        default:
            return assertNever(notification);
    }
};
